<template>
  <div v-loading="loading">
    <div class="title">专栏文章</div>
    <el-table :data="tableList" :stripe="true">
      <el-table-column width="80" label="ID" prop="id"> </el-table-column>
      <el-table-column
        label="专栏标题"
        show-overflow-tooltip
        prop="title"
        width="140"
      ></el-table-column>
      <el-table-column label="关联行业" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            (scope.row.common_industries || []).length
              ? String(
                  scope.row.common_industries.map(data => {
                    return data.name;
                  })
                )
              : "-"
          }}
        </template></el-table-column
      >
      <el-table-column label="难度等级">
        <template slot-scope="scope">
          {{ getDiffcult(scope.row.difficulty_level) }}
        </template>
      </el-table-column>
      <el-table-column
        label="相关岗位"
        width="200"
        prop="job"
      ></el-table-column>
      <!-- <el-table-column label="内容统计" width="140">
        <template slot-scope="scope">
          <div>
            {{ scope.row.chapter_count ? scope.row.chapter_count : 0 }} 章 /
            {{ scope.row.section_count ? scope.row.section_count : 0 }} 节 /
            {{ scope.row.content_length }} 字
          </div>
        </template></el-table-column
      > -->
      <!-- <el-table-column label="节完成度" prop="knowledge_contents_count">
        <template slot-scope="scope">
          <div>{{ scope.row.completion_degree }}%</div>
        </template></el-table-column
      > -->
      <el-table-column width="100">
        <template slot="header">
          <div>
            <span>预计时长</span>
            <el-tooltip
              effect="dark"
              content="预计时长=总字数/平均阅读速度(500字/min)*60+图片数*5"
              placement="top"
            >
              <i class="el-icon-warning" style="cursor: pointer;"></i>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          {{
            scope.row.estimate_reading_time_beautify
              ? scope.row.estimate_reading_time_beautify
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>价格</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="70" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleToAdd(scope.row)"
            >去撰写</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import columnService from "@/global/service/column";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  components: {
    ShowHideContent
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  data() {
    return {
      loading: false,
      isShow: false,
      skill_points: [],
      tableList: [],
      examList: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      levelOptions: [
        {
          label: "L1 - 入门",
          value: 1
        },
        {
          label: "L2 - 初阶",
          value: 2
        },
        {
          label: "L3 - 中阶",
          value: 3
        },
        {
          label: "L4 - 高阶",
          value: 4
        },
        {
          label: "L5 - 资深",
          value: 5
        },
        {
          label: "L6 - 专家",
          value: 6
        }
      ]
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize
      };
      columnService
        .getColumnsList(params)
        .then(res => {
          this.tableList = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goPage(val) {
      this.$router.push({
        name: "ColumnList",
        query: { page: val }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    handleToAdd(data) {
      const id = data.id;
      this.$router.push({
        name: "ColumnInfo",
        params: {
          id
        }
      });
    },
    getDiffcult(level) {
      return this.levelOptions.find(d => d.value == level).label;
    }
  }
};
</script>

<style lang="less">
.skill-task-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
.toggle-show {
  cursor: pointer;
  .toggle-show-icon {
    margin-left: 4px;
  }
  &:hover {
    color: #409eff;
  }
}
</style>
